import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

const JEA_YEAR = 2024;

export const defaultState = {
  jea2024: {
    list: [],
    listLoading: false,
  },
};

export const mutations = {
  JEA2024_SET_LIST(state, list) {
    state.jea2024.list = list;
  },
  JEA2024_SET_LIST_LOADING(state, isLoading) {
    state.jea2024.listLoading = isLoading;
  },
};

export const getters = {
  getJea2024List: state => state.jea2024.list,
  getJea2024ListIsLoading: state => state.jea2024.listLoading,
};

export const actions = {
  // eslint-disable-next-line no-unused-vars
  callJea2024Approve({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/approve`, data)
      .then(result => result.data);
  },
  // eslint-disable-next-line no-unused-vars
  callJea2024Trigger({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/trigger`, data)
      .then(result => result.data);
  },
  fetchJea2024List({ commit }, filterByStatus) {
    commit('JEA2024_SET_LIST_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea?filter_by_status=${filterByStatus}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { jeas } = response;
          commit('JEA2024_SET_LIST_LOADING', false);
          commit('JEA2024_SET_LIST', jeas);
        });
      })
      .catch((error) => {
        commit('JEA2024_SET_LIST_LOADING', false);
        commit('JEA2024_SET_LIST', []);

        return Promise.reject(error);
      });
  },
  fetchJea2024All({ dispatch }, filterByStatus) {
    dispatch('fetchJea2024List', filterByStatus);
  },
  // eslint-disable-next-line no-unused-vars
  fetchJea2024DownloadPdf({ commit }, requestData) {
    const { id } = requestData;

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/pdf/${id}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
};

const jea2024 = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default jea2024;



// WEBPACK FOOTER //
// ./src/store/payout/jea2024.js